import { type OrderItemVendorConstructor } from '../../entities/OrderItemVendor'
import { type VendorDetailApiModel } from '../api-models/VendorDetailApiModel'

export const mapVendorDetailApiModel = ({
  id,
  name,
  active,
  is_auto_email_po_enabled,
}: VendorDetailApiModel): OrderItemVendorConstructor => ({
  id,
  name,
  isAutoEmailPoEnabled: is_auto_email_po_enabled,
  active,
})
